module.exports = __webpack_public_path__ + "img/16.09c5378f.jpg";